/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import './css/Input.css';
import { connect } from 'react-redux';
import InputValue from './InputValue/InputValue';
import Popover from '../Popover/Popover';
import DestinationSearch from './DestinationSearch/DestinationSearch';
import {
  changePopupVisibility,
  changeDepartureDate,
  changeSearchInputValue,
  changeDestinationButton,
  changeNightsButton,
  changeTouristsPopupVisible,
} from '../../../DataStore/actions/searchFormActions';
import {
  HOTEL_ID,
  NIGHTS_ID,
  TO_ID,
  TOURISTS_ID,
} from '../../../Utils/Constants/HomePageConstants';

const mapStateToProps = (state) => ({ ...state });

class Input extends React.Component {
  constructor() {
    super();
    this.node = React.createRef();
    this.buttonRef = React.createRef();

    this.state = {
      popupVisible: false,
    };
  }

  componentDidMount() {
    this.saveRef();
  }

  handleClick = (e) => {
    const {
      id,
      touristsPopupVisible,
      changeTouristsPopupVisible: changeTouristsPopupVisibleAction,
    } = this.props;
    let elementClass;

    if (e && id === TO_ID) {
      elementClass = e.target.getAttribute('class');
      const destinationCrossOpacity = e.target.getAttribute('opacity');
      const viewBox = e.target.getAttribute('viewBox');

      if (
        elementClass === 'sf_dest_search_cross' ||
        destinationCrossOpacity ||
        viewBox
      ) {
        return;
      }

      this.processOutsideListener();
    } else if (id === TOURISTS_ID) {
      this.processOutsideListener();

      changeTouristsPopupVisibleAction(!touristsPopupVisible);
    } else {
      this.processOutsideListener();
    }
  };

  handleOutsideClick = (e) => {
    const { id } = this.props;
    const elementClasses = e.target.getAttribute('class');
    const touristsCrollFillOpacity = e.target.getAttribute('fill-opacity');

    // departure city click - popup should be closed
    if (
      this.node &&
      this.node.current &&
      this.node.current.contains(e.target) &&
      elementClasses === 'sf_pop_departure_item br_text_18'
    ) {
      this.handleClick();
      return;
    }

    if (
      (this.node &&
        this.node.current &&
        this.node.current.contains(e.target)) ||
      (id === TO_ID && elementClasses === 'sf_destination_text') || // for destination input click by text is not a part of button due to search component
      (id === TOURISTS_ID &&
        (elementClasses === 'sf_tourists_cross_but' ||
          elementClasses === 'sf_tourists_cross_ico' ||
          touristsCrollFillOpacity)) // click by tourists cross
    ) {
      return;
    }

    this.handleClick();
  };

  processOutsideListener() {
    const { popupVisible } = this.state;
    const { changeDepartureDate: changeDepartureDateFunc, departureDate } =
      this.props;

    if (!popupVisible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);

      if (!departureDate.to) {
        changeDepartureDateFunc({
          from: departureDate.from,
          to: departureDate.from,
        });
      }
    }

    this.setState((prevState) => ({
      popupVisible: !prevState.popupVisible,
    }));
  }

  handleKeyDown = (e) => {
    const {
      changeSearchInputValue: changeSearchInputValueAction,
      searchInputValue,
    } = this.props;
    if (e.code === 'Space') {
      e.preventDefault();
      changeSearchInputValueAction(`${searchInputValue} `);
    }
  };

  saveRef = () => {
    const {
      id,
      changeDestinationButton: changeDestinationButtonAction,
      changeNightsButton: changeNightsButtonAction,
    } = this.props;

    if (id === TO_ID) {
      changeDestinationButtonAction(this.buttonRef.current);
    } else if (id === NIGHTS_ID) {
      changeNightsButtonAction(this.buttonRef.current);
    }
  };

  renderIco = () => {
    const { id, ico, touristsPopupVisible } = this.props;
    let result;
    if (ico) {
      if (id === TOURISTS_ID) {
        result = (
          <div
            className={`${touristsPopupVisible ? 'input_tourists_but_rotate' : ''}`}
          >
            {ico}
          </div>
        );
      } else {
        result = ico;
      }
    }

    return result;
  };

  render() {
    const { id, label, value, isDesctop } = this.props;
    const { popupVisible } = this.state;

    let inputValue;
    if (id === TO_ID && popupVisible) {
      inputValue = <DestinationSearch />;
    } else {
      inputValue = <InputValue id={id} value={value} />;
    }

    return (
      <div ref={this.node} className="sf_item_inner">
        <button
          type="button"
          className="sf_item_button"
          disabled={id === HOTEL_ID}
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}
          ref={this.buttonRef}
        >
          <div
            className={isDesctop ? 'sf_item_content_w' : 'sf_t_item_content_w'}
          >
            <div className="sf_item_content">
              <div className="br_text_14 opacity05 sf_form_item_title">
                {label}
              </div>
              <div className="sf_item_line_w">
                <div className="bm_text_18">{inputValue}</div>
                {this.renderIco()}
              </div>
            </div>
          </div>
        </button>

        {popupVisible && <Popover id={id} isDesctop={isDesctop} />}
      </div>
    );
  }
}

Input.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  ico: PropTypes.instanceOf(Object),
  departureDate: PropTypes.instanceOf(Object).isRequired,
  changeDepartureDate: PropTypes.func.isRequired,
  changeSearchInputValue: PropTypes.func.isRequired,
  searchInputValue: PropTypes.string.isRequired,
  changeDestinationButton: PropTypes.instanceOf(Object).isRequired,
  changeNightsButton: PropTypes.instanceOf(Object).isRequired,
  isDesctop: PropTypes.bool,
  changeTouristsPopupVisible: PropTypes.func.isRequired,
  touristsPopupVisible: PropTypes.bool.isRequired,
};

Input.defaultProps = {
  value: '',
  isDesctop: false,
  ico: null,
};

export default connect(mapStateToProps, {
  changePopupVisibility,
  changeDepartureDate,
  changeSearchInputValue,
  changeDestinationButton,
  changeNightsButton,
  changeTouristsPopupVisible,
})(Input);
